import React, {useState} from "react";
import * as styles from "./MenuItemTile.module.scss";
import FiberyMenuIcon from "../../../FiberyMenuIcon/FiberyMenuIcon";

function MenuItemTile({iconName, name, description, color, href}) {
  const [isHovered, setHovered] = useState(false);

  return (
    <a href={href} className={styles.root} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <div className={styles.iconWrap}>
        <FiberyMenuIcon type={iconName} fill={isHovered ? color : "#000000"} />
      </div>
      <div className={styles.contentWrap}>
        <div className={styles.title}>{name}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </a>
  );
}
export default MenuItemTile;
